import type { TokenValue } from "@src/components/DefuseSDK/types/base"
import { netDownAmount } from "@src/components/DefuseSDK/utils/tokenUtils"

export type AmountModeFallbackNotice =
  | "execution_balance_limit"
  | "edit_over_balance"

/**
 * Heuristic pre-quote check: is the requested amount too close to the
 * available balance to leave room for slippage?
 */
export function isNearFullBalance(
  requestedAmount: TokenValue,
  availableBalance: TokenValue | undefined,
  slippageBasisPoints: number
): boolean {
  if (availableBalance == null) return false
  return (
    requestedAmount.amount >
    netDownAmount(availableBalance.amount, slippageBasisPoints)
  )
}

/**
 * Authoritative check: does the quoted amountIn exceed the user's balance?
 */
export function exceedsBalance(
  amountIn: bigint,
  availableBalance: TokenValue | undefined
): boolean {
  if (availableBalance == null) return false
  return amountIn > availableBalance.amount
}
